// eslint-disable-next-line max-classes-per-file, import/no-cycle
import Task1 from './task1';
import Team from './team';

class Employee {
  id;

  fullName;

  firstName;

  lastName;

  gender;

  designation;

  department;

  profilePhotoSrc;

  location;

  externalEmployeeId;

  displayName;

  joiningDate;

  country;

  lastUserEvent;

  userRole;

  planType;

  ethnicity;

  jobFunctionId;

  jobGradeUI;

  jobGradeNameUI;

  jobRoleId;

  employeeFunction;

  role;

  canCreateSharedCohort;

  timezone;

  email;

  workEmail;

  personalEmail;

  manager;

  organization;

  // Below properties are only required for employee creation

  teams;

  tenure;

  resignationDate;

  organizationStatus;

  dateOfBirth;

  experienceBeforeJoining;

  customFields;

  companyId;

  constructor(props, json) {
    if (props) this.fromProps(props);
    if (json) this.fromJSON(json);
  }

  fromProps = ({ id, fullName, name }) => {
    this.id = id;
    this.fullName = fullName;
    this.name = name;
  };

  // expects employeeProfile object
  addProfilePhoto = (res) => {
    this.profilePhotoSrc = res != null ? res.profilePhoto : '';
  };

  addDetailsFromMetaPojoJSON(res) {
    if (res != null) {
      this.firstName = res.firstName;
      this.lastName = res.lastName;
      this.fullName = res.displayName || '';
      this.gender = res.gender;
      this.designation = res.designation || '';
      this.department = res.department || '';
      this.location = res.location || '';
      this.tenure = res.tenure != null ? res.tenure.displayData : null;
      this.email = res.email;
      this.workEmail = res.workEmail || '';
      this.personalEmail = res.personalEmail || '';
      this.externalEmployeeId = res.externalEmployeeId;
      this.displayName = res.displayName;
      this.joiningDate = res.joiningDate;
      this.resignationDate = res.resignationDate;
      this.country = res.country;
      this.dateOfBirth = res.dateOfBirth;
      this.manager = {
        email: res.managerEmail,
      };
      this.employeeFunction = res.employeeFunction;
      this.grade = res.grade;
      this.ethnicity = res.ethnicity;
      this.jobFunctionId = res.jobFunctionId;
      this.jobGradeUI = res.jobGradeUI;
      this.jobGradeNameUI = res.jobGradeNameUI;
      this.jobRoleId = res.jobRoleId;
      this.employeeFunction = res.employeeFunction;
      this.role = res.role;
      this.experienceBeforeJoining = res.experienceBeforeJoining;
      this.customFields = res.customFields;
      this.companyId = res.companyId;
    }
  }

  fromJSON(res = {}) {
    this.isSignUpCompletionPending = res.signUpCompletionPending;
    this.addDetailsFromMetaPojoJSON(res.metadata);
    this.profilePhotoSrc = res?.profile?.profilePhoto;
    this.active = res.active;
    this.addTeams(res.teams || res.teamBasicDetails);
    this.id = res.uuid;
    this.lastUserEvent = res.lastUserEvent;
    this.userRole = res.userRole;
    this.invitedUser = res.invitedUser;
    this.image = res?.profile?.profilePhoto;
    this.ownerType = res.ownerType || Task1.EMPLOYEE_TYPES.collaborator;
    // this.managerName = res.managerName ?? '';
    // this.managerEmpId = res.managerEmpId;
    // this.managerProfilePhoto = res.managerProfilePhoto ?? '';
    // this.invitedUser = true;
    // if (res.organization) {
    //   const {
    //     uuid: id,
    //     orgName,
    //     planType,
    //     currency,
    //     organizationStatus,
    //     country,
    //     objectiveSettings,
    //   } = res.organization;
    //   this.organization = {
    //     id,
    //     name: orgName,
    //     planType,
    //     organizationStatus,
    //     country,
    //     currency,
    //     objectiveSettings,
    //   };
    // } else {
    //   this.organization = {
    //     id: null,
    //     name: null,
    //     planType: null,
    //     organizationStatus: null,
    //     country: null,
    //     objectiveSettings: null,
    //   };
    // }
    this.authToken = res.authToken ?? null;
    this.employeeAccesses = res.employeeAccesses ?? [];
    this.managerName = res.managerName ?? '';
    this.managerEmpId = res.managerEmpId;
    this.managerProfilePhoto = res.managerProfilePhoto ?? '';
    this.organization = {};
    this.organization.id = res.organizationId;
    this.canCreateSharedCohort = res.canCreateSharedCohort;
    this.metadata = res.metadata;
    this.timezone = res.timezone;
    this.customFields = res.customFields;
    this.companyId = res.companyId;
  }

  /**
   * @deprecated 08-04-2025
   */
  getProfileImage = () => {
    if (this.profilePhotoSrc) {
      return this.profilePhotoSrc;
    }
    return '';
  };

  addTeams = (teamsJSON = []) => {
    const teams = [];
    teamsJSON && teamsJSON.forEach((teamJSON) => teams.push(Team.fromJSON(teamJSON)));
    this.teams = teams;
  };

  static getEmployeeObjectFromRes(res = {}) {
    const emp = new Employee({});
    emp.fromJSON(res);
    return emp;
  }

  // if any of the team contains MANAGER role for this employee
  // then the employee is a manager
  isManager = () => {
    if (!this.teams) return false;
    for (let i = 0; i < this.teams.length; i++) {
      if (this.teams[i].isRoleManager()) return true;
    }
  };

  isPreferredTeamManager = () => {
    if (!this.teams) return false;
    const preferredTeam = this.teams.filter((t) => t.teamType === 'DEFAULT')[0];
    if (preferredTeam && preferredTeam.userRole === 'MANAGER') {
      return true;
    }
    return false;
  };

  isSuperAdmin = () => this.userRole && this.userRole === 'ADMIN';

  /**
   * @deprecated 08-04-2025
   */
  getFirstTeam = () => {
    if (!this.teams) {
      return null;
    }
    return this.teams[0];
  };

  getMyManagerTeams = () => {
    if (!this.teams) return [];
    return this.teams.filter((team) => team.isRoleManager());
  };

  /**
   * @deprecated 08-04-2025
   */
  getSearchLabel = () => {
    const result = [];
    if (this.displayName) result.push(this.displayName);
    if (this.location) result.push(this.location);
    if (this.designation) result.push(this.designation);
    return result.join(', ');
  };
}

export default Employee;

export function getPrimaryPod() {
  return this.teams ? this.teams.filter((team) => team.isPrimaryPod())[0] || { name: '' } : { name: '' };
}

export class BasicEmployee {
  constructor({ id, displayName, designation, profilePhotoSrc }) {
    this.id = id;
    this.displayName = displayName;
    this.profilePhotoSrc = profilePhotoSrc;
    this.designation = designation;
  }

  static fromJSON({ id, displayName, designation, profilePhoto: profilePhotoSrc }) {
    return new BasicEmployee({
      id,
      displayName,
      designation,
      profilePhotoSrc,
    });
  }
}
